function arrayToParagraph() {

  return (addressObj) => {

    const address = [];

    Object.keys(addressObj).forEach((line) => {

      if (addressObj[line]) {

        address.push(addressObj[line]);

      }

    });

    return address.join('<br />');

  };

}

export default arrayToParagraph;


// WEBPACK FOOTER //
// ./src/utils/array.paragraph.js